'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { BackIcon } from '@repo/ui/icons/BackIcon';
import { Typography } from '@repo/ui/Typography';
import { useIsFirstStep, useIsFunnelSubmitting, useStepProgress } from '@/features/funnel/model/Context/hooks';
import { useIsExitIntentEnabled } from '@/features/funnel/model/exit-intent/Context';
import type { CardTypeOption } from '@/features/funnel/model/exploreOtherCardTypes';
import { useFunnelNavigation } from '@/features/funnel/model/useFunnelNavigation';
import { CloseFlow } from '@/features/funnel/ui/CloseFlow';
import { ExploreOtherCardTypesBanner } from '@/features/funnel/ui/explore-other-card-types/Banner';
type Props = {
  isExploreOtherCardTypesEnabled: boolean;
  branchOptions: CardTypeOption[];
};
export function Header(t0) {
  const $ = _c(32);
  const {
    isExploreOtherCardTypesEnabled,
    branchOptions
  } = t0;
  const {
    goBack
  } = useFunnelNavigation();
  const isFirstStep = useIsFirstStep();
  const percentage = useStepProgress();
  const isExitIntentEnabled = useIsExitIntentEnabled();
  const isSubmitting = useIsFunnelSubmitting();
  let t1;
  if ($[0] !== branchOptions || $[1] !== isExploreOtherCardTypesEnabled) {
    t1 = isExploreOtherCardTypesEnabled && <ExploreOtherCardTypesBanner options={branchOptions} />;
    $[0] = branchOptions;
    $[1] = isExploreOtherCardTypesEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "3",
      sm: {
        gap: "4"
      },
      pt: {
        base: "[16px]",
        sm: "4"
      },
      pb: {
        base: "[12px]"
      }
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== goBack || $[5] !== isFirstStep || $[6] !== isSubmitting) {
    t3 = !isFirstStep && <button type="button" className={css({
      display: "flex",
      alignItems: "center",
      gap: "1",
      bg: "[transparent]",
      border: "none",
      cursor: "pointer",
      color: "neutral.darkest",
      py: "1",
      px: "2",
      rounded: "sm",
      _hover: {
        bg: "neutral.lightest"
      }
    })} onClick={goBack} disabled={isSubmitting} aria-label="Go back to the previous step"><BackIcon /><Typography as="span" variant="body" css={{
        fontWeight: "semibold"
      }}>Back</Typography></button>;
    $[4] = goBack;
    $[5] = isFirstStep;
    $[6] = isSubmitting;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `${percentage} percent complete`;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      flex: "[1]",
      alignSelf: "center",
      height: "[8px]",
      bg: "neutral.lighter-2",
      rounded: "full",
      overflow: "hidden"
    });
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `${percentage}%`;
  let t7;
  if ($[9] !== t6) {
    t7 = {
      width: t6
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      height: "[100%]",
      bg: "nwGreens.light",
      rounded: "full",
      transition: "all"
    });
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <div style={t7} className={t8} />;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== percentage || $[15] !== t4 || $[16] !== t9) {
    t10 = <div role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percentage} aria-valuetext={t4} aria-label="Quiz progress" className={t5}>{t9}</div>;
    $[14] = percentage;
    $[15] = t4;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      color: "neutral.darker",
      fontWeight: "semibold",
      whiteSpace: "nowrap"
    };
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== percentage) {
    t12 = <Typography as="span" variant="body.small" aria-hidden="true" css={t11}>{percentage}%</Typography>;
    $[19] = percentage;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isExitIntentEnabled || $[22] !== isExploreOtherCardTypesEnabled) {
    t13 = !isExitIntentEnabled && !isExploreOtherCardTypesEnabled && <div className={css({
      display: {
        base: "flex",
        lg: "none"
      }
    })}><CloseFlow /></div>;
    $[21] = isExitIntentEnabled;
    $[22] = isExploreOtherCardTypesEnabled;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t13 || $[27] !== t3) {
    t14 = <div className={t2}>{t3}{t10}{t12}{t13}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t1 || $[30] !== t14) {
    t15 = <>{t1}{t14}</>;
    $[29] = t1;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}